import ReactDOM from 'react-dom';
import { isiPhone, isMobile } from 'utils/HTMLUtils';
import App from './App';
import './index.scss';
import * as serviceWorker from './utils/serviceWorker';
import { NumberUtilsInit } from './utils/NumberUtils';

const detectIE = () => {
  const ua = window.navigator.userAgent;

  const msie = ua.indexOf('MSIE ');
  if (msie > 0) {
    // IE 10 or older => return version number
    return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
  }

  const trident = ua.indexOf('Trident/');
  if (trident > 0) {
    // IE 11 => return version number
    const rv = ua.indexOf('rv:');
    return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
  }

  const edge = ua.indexOf('Edge/');
  if (edge > 0) {
    // Edge (IE 12+) => return version number
    return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
  }

  // other browser
  return false;
};

NumberUtilsInit();

const notSupportedIEElements = () => {
  return (
    <div id='ie-not-supported'>
      <br />
      A aplicação não possui suporte ao Internet Explorer.
      <br />
      Você pode utilizar o{' '}
      <a
        href='https://www.google.com/intl/pt-BR/chrome/'
        target='_blank'
        rel='noopener noreferrer'
      >
        Google Chrome
      </a>
      .
    </div>
  );
};

const root = document.getElementById('root') as HTMLElement;
if (isMobile()) {
  root.classList.add(isiPhone() ? 'iphone' : 'mobile');
}
ReactDOM.render(detectIE() ? notSupportedIEElements() : <App />, root);
serviceWorker.unregister();
